import { createSelector } from '@reduxjs/toolkit'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitActualsAndTargetsSettings = createSelector(
  selectFinancialCockpitState,
  ({ actualsAndTargetsSettings }) => actualsAndTargetsSettings
)
